import React from 'react';
import './portfolio.scss'
import { Divider } from 'antd';
import MyProject from '../../components/MyProject';

const Portfolio = () => {
  const project = [
    {
      title: 'Crown-clothing | React-Redux',
      text: 'Через приложение вы можете купить качественные товары не выходя из дома.',
      img: 'projectImg/crown.png',
      adaptive: 'Приложение не адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Styled-Components', 'React js', 'Redux', 'Redux-thunk'],
      url: 'https://crown-clothing-wb.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/cown-clothing/tree/master',
    },
    {
      title: 'Quiz App | React',
      text: 'В этом приложение вы можете закрепить своё знание отвечавь вопросы.',
      img: 'projectImg/quizApp.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
      url: 'https://quizapp21.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/QuizApp',
    },
    {
      title: 'Olmo.uz | React',
      text: 'Приложение сделано для усвоение навыков.',
      img: 'projectImg/olmo.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Material-UI', 'React js'],
      url: 'https://olmo.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/olmo',
    },
    {
      title: 'Tour App SPA | Typescript',
      text: 'Приложение сделано для усвоение навыков.',
      img: 'projectImg/tour.png',
      adaptive: 'Приложение не адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Antd-design', 'React js', 'Typescript'],
      url: 'https://tour-ws.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/tourApp',
    },
    {
      title: 'Online Shopping | React',
      text: 'Через приложение вы можете купить качественные товары не выходя из дома.',
      img: 'projectImg/shopping.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'React js', 'React-redux', 'Redux Toolkit'],
      url: 'https://e-commerce-21.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/e-commerce/tree/master ',
    },
    {
      title: 'Get Weather | React',
      text: 'Приложение предоставляет национальный и местный прогноз погоды для городов.',
      img: 'projectImg/weather.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
      url: 'https://obhavoweather.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/Weather_App_React/tree/weather',
    },
    {
      title: 'Todo App | Typescript',
      text: 'С помощью этой приложений вы можете создать свой todo-list.',
      img: 'projectImg/todo.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Materialize', 'React js', 'Typescript'],
      url: 'https://todoappts.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/todo_app_typescript/tree/todo',
    },
    {
      title: 'QRCode | React',
      text: 'С помощью этой приложений вы можете генерировать свой QRCode.',
      img: 'projectImg/qr.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'React js'],
      url: 'https://qrcode-21.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/QRCode/tree/qrcode',
    },
    {
      title: 'You Tube Clone version | React',
      text: 'Приложение клон сайта youtube.com.',
      img: 'projectImg/youtube.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
      url: 'https://youtubeclone-21.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/you_tube_clone/tree/youtube',
    },
    {
      title: 'Cryptocurrency FP | React',
      text: 'Приложение представит вам Cryptocurrency Finance Price.',
      img: 'projectImg/crypto.png',
      adaptive: 'Приложение не адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
      url: 'https://cryptocurrency-21.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/Cryptocurrency-Finance-Price/tree/crypto',
    },
    {
      title: 'Albison SPA | React',
      text: 'Приложение сделано для усвоение навыков.',
      img: 'projectImg/albison.png',
      adaptive: 'Приложение адаптивным состояние.',
      technologies: ['HTML5', 'CSS3/SASS', 'Antd-design', 'React js'],
      url: 'https://albison-ws.netlify.app/',
      urlGithub: 'https://github.com/Ibragimovrustam21/albison/tree/albison',
    }
  ]
  return (
    <div className='portfolio content' >
      <div className='divider-box'>
        <Divider className='title' orientation="left">
          <h3><span>03.</span>Портфолио</h3>
        </Divider>
      </div>
      <div className='my-projects'>
        {
          project.map((item, key) => {
            const { title, text, adaptive, technologies, url, urlGithub, animeTime, img } = item
            return (
              <MyProject
                key={key}
                title={title}
                text={text}
                adaptive={adaptive}
                technologies={technologies}
                url={url}
                urlGithub={urlGithub}
                animeTime={animeTime}
                img={img}
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default Portfolio